import * as _ from "lodash";
import React, {Fragment, Component} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import InputMask from "react-input-mask";
import {
    Grid,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Form as LocationForm} from "../../vendors/redux/reducers/locationForm";
import {Form as CaseForm} from "../../vendors/redux/reducers/caseForm";
import {locationFormChange, locationFormReset, locationFormFieldReset} from '../../vendors/actions/location';
import {getCourts, getDepartments, resetCourts, resetDepartments} from '../../vendors/actions/static'
import {isMobileBrowser} from '../../vendors/utils/common';

interface OwnProps {
    caseData?: any
    inline?: any,
    edit?: any
}

interface ConnectStateProps {
    CaseForm: CaseForm
    LocationForm: LocationForm
    Courts: Array<any>,
    Departments: Array<any>,
    States: Array<any>,
}

interface MainState {
    countyId: any,
    departments: Array<any>
}

interface ConnectDispatchProps {
    locationFormChange: (data: any) => void;
    locationFormReset: () => void;
    locationFormFieldReset: (data: any) => void;
    getCourts: (countyId: number) => void;
    resetCourts: () => void;
    getDepartments: (courtId: number) => void;
    resetDepartments: () => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

const PostalCodeMask = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            placeholder={''}
            mask="99999"
            maskChar=""/>
    )
};

const TextFieldComponent = (params: any, error: any, label: string) => {
    return (
        <TextField
            {...params}
            error={!!error}
            helperText={error}
            label={label}
            variant="outlined"
            fullWidth
        />
    )
};

const addManually = (arr: Array<any>) => {
    const addManualExists = arr.find((c: any) => c.id == '-2');
    if (!addManualExists) {
        arr.push({
            id: -2,
            name: 'Add Manually'
        })
    }
};


class Location extends Component<HeaderProps, MainState> {
    state = {
        countyId: null,
        departments: [],
    };

    private departmentRef: any = React.createRef<HTMLDivElement>();
    private courtRef: any = React.createRef<HTMLDivElement>();

    componentDidMount(): void {
        const {caseData, Courts, Departments} = this.props;


        if (caseData) {
            addManually(Courts);
            addManually(Departments);

            const court = Courts.find((c: any) => c.id == caseData.court_id),
                department = Departments.find((c: any) => c.id == caseData.department_id);

            this.setState({departments: Departments})

            this.selectCourt(null, court);
            this.selectDepartment(null, department);
            this.changeForm({target: {value: caseData.city || ''}}, 'city');
            this.changeForm({target: {value: caseData.street || ''}}, 'street');
            this.changeForm({target: {value: caseData.zip || ''}}, 'zip');
        }
    }

    componentWillUnmount(): void {
        this.props.locationFormReset();
    }

    componentDidUpdate(prevProps: Readonly<HeaderProps>, prevState: Readonly<MainState>, snapshot?: any): void {

        const {caseData, Departments} = this.props;
        const countyId = this.props.CaseForm.data.county?.value?.id;

        if (!_.isEqual(this.state.departments, Departments)) {
            this.setState({departments: Departments})
        }

        if (!_.isEqual(prevState.countyId, countyId) && countyId) {
            this.setState({countyId: _.clone(countyId)});

            if (prevState.countyId) {
                //hack mui autocomplete clear
                const court = this.courtRef.querySelector('.MuiAutocomplete-clearIndicator');
                court && court.click();
                //hack mui autocomplete clear
            }
        }
    }

    changeForm = (e: any, field: string, validate: boolean = false): void => {
        let value = e.target.value;

        this.props.locationFormChange({value, field, validate});

        this.buildFullAddress()
    };

    selectCourt = (e: any, value: any) => {

        const {LocationForm: {data: form}} = this.props;

        this.resetAddManuallyFields(form, value, 'court');

        this.props.locationFormChange({value, field: 'court'});
        this.props.resetDepartments();

        if (value?.id == -2) {
            this.props.locationFormChange({
                value: {
                    id: -2,
                    name: 'Add Manually'
                },
                field: 'department'
            });
        } else {
            this.props.locationFormChange({value: null, field: 'department'});
            if (e) {
                //hack mui autocomplete clear
                const department = this.departmentRef.querySelector('.MuiAutocomplete-clearIndicator');
                department && department.click();
                //hack mui autocomplete clear
            }

            if (value && value.id > 0) {
                this.props.getDepartments(value.id);
            }
        }
    };

    selectDepartment = (e: any, value: any) => {
        const {LocationForm: {data: form}} = this.props;

        this.resetAddManuallyFields(form, value, 'department');

        this.props.locationFormChange({value: null, field: 'full_address'});

        this.props.locationFormChange({value, field: 'department'});

        this.buildFullAddress()
    };

    resetAddManuallyFields(form: any, value: any, field: string) {
        if (form[field]?.value && form[field]?.value.id == -2 && value && value.id != -2) {
            this.props.locationFormFieldReset({field: 'city'})
            this.props.locationFormFieldReset({field: 'zip'})
            this.props.locationFormFieldReset({field: 'street'})
        }
    }

    buildFullAddress() {
        const {caseData, States} = this.props;
        const {department, court, city, street, zip} = this.props.LocationForm.data;
        let abbrv = '';

        if (caseData) {
            const state = States.find((s: any) => s.id === caseData.state_id);
            abbrv = state.abbreviation;
        } else {
            abbrv = this.props.CaseForm.data?.state?.value?.abbreviation;
        }

        if (department?.value?.id && department?.value?.id != -2) {
            //let {city, courtZipCode} = court?.value;
            let address = '';
            let city = (court?.value && court?.value.city) ? court?.value.city : '';
            let courtZipCode = (court?.value && court?.value.courtZipCode) ? court?.value.courtZipCode : '';
            if ((court?.value && !court?.value.address)) {
                address = department?.value?.departmentAddress;
            } else {
                address = court?.value.address
            }

            const value = `${address ? `${address},` : ''} ${city ? `${city},` : ''} ${abbrv ? `${abbrv} ${courtZipCode ? ',' :''}` : ''} ${courtZipCode}`;
            this.props.locationFormChange({value, field: 'full_address'});
        } else if (department?.value?.id) {

            const value = `${street?.value}, ${city?.value}, ${abbrv ? `${abbrv},` : ''} ${zip?.value}`;
            this.props.locationFormChange({value, field: 'full_address'});
        }

    }


    render() {

        const {
            LocationForm: {data: form},
            Courts: courts,
            // Departments: departments,
            inline = true,
            edit = false
        } = this.props;

        const {departments} = this.state;

        addManually(courts);

        if (form?.court?.value) {
            addManually(departments);
        }

        return (
            <Fragment>
                <form className="w-100 location-form consumer-style">
                    <div className="text-field-custom-mb">
                        <Autocomplete
                            className='w-100'
                            id="select-court"
                            options={courts}
                            ref={ref => this.courtRef = ref}
                            value={form?.court?.value || {id: null, name: ''}}
                            onChange={this.selectCourt}
                            getOptionLabel={(option: any) => option.name}
                            renderInput={params => TextFieldComponent(params, form?.court?.error, 'Courthouse')}
                        />
                    </div>

                    <div className="text-field-custom-mb">
                        <Autocomplete
                            id="select-department"
                            options={departments}
                            ref={ref => this.departmentRef = ref}
                            value={form?.department?.value}
                            getOptionSelected={(optionToEval: any, valueToEval: any) => {
                                return optionToEval.id == valueToEval.id
                            }}
                            onChange={this.selectDepartment}
                            getOptionLabel={(option: any) => option.name}
                            renderInput={params => TextFieldComponent(params, form?.department?.error, 'Department')}
                        />
                    </div>

                    {form?.department?.value?.id !== -2 && <div className="text-field-custom-mb">
                        <TextField
                            fullWidth
                            disabled={!form?.full_address?.value}
                            value={form?.full_address?.value || ''}
                            label={form?.full_address?.value ? 'Address' : 'Please fill in courthouse and department info.'}
                            id="address"
                            variant="outlined"
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </div>}

                    {form?.department?.value?.id == -2 && <div>
                        <div className="text-field-custom-mb">
                            <TextField
                                fullWidth
                                error={!!form?.street?.error && form?.street?.dirty}
                                value={form?.street?.value || ''}
                                helperText={form?.street?.error && form?.street?.dirty ? form?.street?.error : ''}
                                onChange={(e) => this.changeForm(e, 'street', true)}
                                onBlur={(e) => this.changeForm(e, 'street', true)}
                                label="Street Address"
                                id="street"
                                variant="outlined"
                            />
                        </div>
                        <Grid container spacing={inline && !isMobileBrowser()? 3 : 0} className={'align-end'}>
                            <Grid
                                item
                                xs={12}
                                md={inline ? 6 : 12}
                                lg={inline ? 6 : 12}
                                className="d-flex align-center">
                                <div className="w-100 text-field-custom-mb">
                                    <TextField
                                        fullWidth
                                        error={!!form?.city?.error && form?.city?.dirty}
                                        value={form?.city?.value || ''}
                                        helperText={form?.city?.error && form?.city?.dirty ? form?.city?.error : ''}
                                        onChange={(e) => this.changeForm(e, 'city', true)}
                                        onBlur={(e) => this.changeForm(e, 'city', true)}
                                        label="City"
                                        id="city"
                                        variant="outlined"
                                    />
                                </div>

                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={inline ? 6 : 12}
                                lg={inline ? 6 : 12}
                                className="d-flex align-center text-field-custom-mb">
                                <div className="w-100 text-field-custom-mb">
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="Zip Code"
                                        value={form?.zip?.value || ''}
                                        error={!!form?.zip?.error && form?.zip?.dirty}
                                        helperText={form?.zip?.error && form?.zip?.dirty ? form?.zip?.error : ''}
                                        onChange={(e) => this.changeForm(e, 'zip', true)}
                                        onBlur={(e) => this.changeForm(e, 'zip', true)}
                                        id="zip"
                                        InputProps={{
                                            inputComponent: PostalCodeMask,
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>}

                </form>
            </Fragment>
        )
    }
}


type ConnectStateMapper = MapStateToProps<ConnectStateProps, Object>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Courts, Departments, CaseForm, LocationForm, States} = state;
    return {
        Courts,
        Departments,
        CaseForm,
        LocationForm,
        States
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, Object>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        locationFormReset: () => dispatch(locationFormReset()),
        locationFormFieldReset: (data: any) => dispatch(locationFormFieldReset(data)),
        locationFormChange: (data: any) => dispatch(locationFormChange(data)),
        getCourts: (countyId: number) => dispatch(getCourts(countyId)),
        resetCourts: () => dispatch(resetCourts()),
        getDepartments: (courtId: number) => dispatch(getDepartments(courtId)),
        resetDepartments: () => dispatch(resetDepartments()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Location);
